exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.navbar-container[data-v-32b88766]{\n    height: 3.5rem;\n    min-height: 3.5rem !important;\n}\n.navbar[data-v-32b88766] {\n    z-index: 1035 !important;\n    max-width: 576px;\n    height: inherit;\n    right: 0;\n    left: 0;\n    background-color: inherit;\n    color: inherit;\n}\n.navbar-shadow[data-v-32b88766] {\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\n}\n.wider[data-v-32b88766] {\n    width: 16.25rem;\n}\n", ""]);

// exports
